import {useState} from 'react'
import { useBAData } from "../../context";
import { when, both, equals, head, last, drop, dropLast, compose } from 'ramda';



export const UploadDisplay = () => {
    const [file, setFile] = useState();
    const {setUploadedData, activeBAData} = useBAData()

    const fileReader = new FileReader();

    const handleOnChange = (e) => {
        setFile(e.target.files[0]);
        const file = e.target.files[0];
        if (file) {
          document.querySelector(".file-name").textContent = file.name;
        }
    };
    const removeWrappingQuotes = when(
        both(compose(equals('"'), head), compose(equals('"'), last)),
        compose(drop(1), dropLast(1))
      );

    const csvFileToArray = string => {
        const csvHeader = string.slice(0, string.indexOf("\n")).split(",");
        const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");
        const trimmedCsvHeader= csvHeader.map(item => removeWrappingQuotes(item))
    
        const array = csvRows.map(i => {
          const values = i.split(",");
          const trimmedValues = values.map(v => removeWrappingQuotes(v))
          const obj = trimmedCsvHeader.reduce((object, header, index) => {
            object[header] = trimmedValues[index];
            return object;
          }, {});
          return obj;
        });
        // console.log({array})
        // console.log("mapped array: " + array.map(arr => arr.ID))
        setUploadedData(array.map(arr => arr.ID)) 
      };

    const handleOnSubmit = (e) => {
        e.preventDefault();
        if (file) {
        fileReader.onload = function (event) {
            const csvOutput = event.target.result;
            csvFileToArray(csvOutput)
        };

        fileReader.readAsText(file);
        }
    };

    const handleClear = (e) => {
        e.preventDefault()
        setUploadedData([])
    }
    return (
        <div>
            <form>
                {/* <input
                type={"file"}
                id={"csvFileInput"}
                accept={".csv"}
                onChange={handleOnChange}
                /> */}
                <style>
                    {`
                        .custom-upload-btn {
                        background-color: #22356E !important;
                        color: white !important;
                        border: none;
                        }
                        .custom-upload-btn:hover {
                        background-color: #1a2857 !important; /* Slightly darker shade for hover */
                        }
                    `}
                </style>
                <div className="is-flex is-justify-content-center" style={{marginBottom: "1rem"}}>
                <div className="file has-name">
                    <label className="file-label">
                        <input
                        className="file-input"
                        type="file"
                        id="csvFileInput"
                        accept=".csv"
                        onChange={handleOnChange}
                        />
                        <span className="file-cta custom-upload-btn">
                        <span className="file-icon">
                            <i className="fas fa-upload"></i>
                        </span>
                        <span className="file-label">Upload CSV</span>
                        </span>
                        <span className="file-name">No file selected</span>
                    </label>
                </div>
                </div>
                <div style={{marginTop: "1rem", marginBottom: "1rem"}}>
                <div
                className="button"
                onClick={(e) => {
                    handleOnSubmit(e);
                }}
                >
                IMPORT CSV
                </div>
                <div className="button" onClick={handleClear}>
                    Clear
                </div>
                </div>

            </form>
        </div>
    )
}